import React from 'react';
import { createRoot } from 'react-dom/client';
import SubscriptionAlertPopup from '../components/SubscriptionAlertPopup';

export function showSubscriptionAlertPopup({ title, messageStr }) {
  const container = document.createElement('div');
  document.body.appendChild(container);

  const root = createRoot(container); // Create a root

  const cleanup = () => {
    root.unmount();        // Unmount the component
    container.remove();    // Clean up DOM
  };

  root.render(
    <SubscriptionAlertPopup
      title={title}
      message={messageStr}
      onClose={cleanup}
    />
  );
}
